import { Component, OnInit } from '@angular/core';
import { AlertController, LoadingController, ModalController, NavParams, Platform } from '@ionic/angular';
import CONFIG from '../../../config';
import { EvidenciaObacService } from 'src/app/services/evidencia-obac.service';

@Component({
  selector: 'app-visualizar-imagen-obac',
  templateUrl: './visualizar-imagen-obac.page.html',
  styleUrls: ['./visualizar-imagen-obac.page.scss'],
})
export class VisualizarImagenObacPage implements OnInit {

  evidencia: any = {}
  idincidenciaMR = 0
  evidencias: any[] = []
  finalizado: boolean = false;
  base64: string = '';
  rutaImg = CONFIG.API + '/imagesobac/'
  constructor(public navParams: NavParams, public modalCtrl: ModalController,
    public alertController: AlertController,
    public loadingController: LoadingController,
    public evidenciaOBAC: EvidenciaObacService, public platform: Platform) {
    this.cargarDatos()
  }
  slideOpts = {
    initialSlide: 0,
    slidesPerView: 1,
    autoplay: true,
  };

  ngOnInit() {
  }

  cargarDatos() {
    //console.log(this.navParams);
    this.idincidenciaMR = this.navParams.get('id');
    this.evidencia = this.navParams.get('evidencia');
    console.log(this.evidencia);
    this.finalizado = this.navParams.get('finalizado');
    if (this.evidencia) {
      this.evidencia.ruta = this.rutaImg + this.navParams.get('evidencia').imagen;
    }

    //para múltiples imagenes 
    let evidencias = this.navParams.get('evidencias');
    if (evidencias > 0) {
      for (const evidencia of evidencias) {
        evidencia.ruta = this.rutaImg + evidencia.imagen;
        this.evidencias.push(evidencia);
      }
    }

  }


  async cerrar() {
    this.modalCtrl.dismiss({
      'dismissed': true
    });
  }


  async cambiarImagen(evt) {
    this.base64 = await this.fileTobase64(evt.target.files[0])
  }

  fileTobase64(file): Promise<any> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    })
  }

  async subirImagen() {
    if (this.base64) {
      const loading = await this.loadingController.create({
        message: 'Reemplazando imagen...',
        spinner: 'lines'
      });
      await loading.present();

      this.evidenciaOBAC.reemplazarImagen(this.evidencia.id, { base64: this.base64 })
        .then(data => {
          console.log(data);
          loading.dismiss();
          this.base64='';
          this.evidenciaOBAC.getEvidencia(this.evidencia.id)
            .then((evidencia:any) => {
              console.log(evidencia);
              this.evidencia = evidencia;
              this.evidencia.ruta = this.rutaImg+evidencia.imagen;
            })
        })
        .catch(err => {

        })
    } else {
      this.mensajes('Reemplazar imagen OBAC', '', 'No has seleccionado ninguna imagen')
    }
  }

  async mensajes(header, subHeader, message) {
    const alert = await this.alertController.create({
      header: header,
      subHeader: subHeader,
      message: message,
      buttons: ['Aceptar']
    });

    await alert.present();
  }
}